import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../static/styles/RewardClaimPopup.module.css';
import goldCoinsImage from '../static/img/imageGoldCoins.svg';

const RewardClaimPopup = ({ isOpen, onClose, credits = 15 }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className={styles.popupOverlay} onClick={onClose}>
      <div className={styles.popupContent} onClick={(e) => e.stopPropagation()}>
        <h2 className={styles.title}>{t('popups.congratulations')}</h2>
        <div className={styles.coinsContainer}>
          <div className={styles.glitterParticle} />
          <div className={styles.glitterParticle} />
          <div className={styles.glitterParticle} />
          <div className={styles.glitterParticle} />
          <div className={styles.glitterParticle} />
          <img src={goldCoinsImage} alt="Gold Coins" className={styles.coinsImage} />
        </div>
        <div className={styles.credits}>{t('day_item.credits_amount', { count: credits })}</div>
        <button className={styles.rewardButton} onClick={onClose}>
          {t('popups.daily_reward_claim')}
        </button>
      </div>
    </div>
  );
};

export default RewardClaimPopup;